import Icon from "../ui/Icon.jsx";

/**
 * 진행 중인 토론이 있을 때 주제 목록보다 먼저 보여준다.
 * 한도는 이미 그 토론에 나갔으므로, 버리면 오늘은 더 못 한다 — 그걸 분명히 말한다.
 */
export default function Resume({ session, onContinue, onLeave }) {
  const { debate, turns } = session;
  const lastQuestion = [...turns].reverse().find((t) => t.speaker === "ai" && t.meta?.question)?.meta?.question;
  const done = turns.length;

  return (
    <main className="screen" style={{ background: "var(--paper)", minHeight: "100vh" }}>
      <header className="bar">
        <span className="logo">그래서요<span className="q">?</span></span>
        <span className="grow" />
        <span className="pill">오늘 남은 토론 0</span>
      </header>

      <h1 className="title">하던 토론이 있어요</h1>

      <article className="card cream raised" style={{ borderRadius: 4 }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 8 }}>
          <span className="pill mark" style={{ fontSize: 12 }}>{done}/6까지 했어요</span>
        </div>
        <h2 className="d" style={{ fontSize: 26, lineHeight: 1.2 }}>{debate.topicSnapshot?.title}</h2>
        <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
          <span className="pill mark" style={{ fontSize: 12 }}>나 · {debate.stanceLabel}</span>
          <span className="pill alert" style={{ fontSize: 12 }}>AI · 반대편</span>
        </div>
        <div className="dots">
          {[1, 2, 3, 4, 5, 6].map((n) => {
            const t = turns.find((x) => x.seq === n);
            const cls = t ? (t.speaker === "ai" ? "dot ai" : "dot done") : n === done + 1 ? "dot now" : "dot todo";
            return <span key={n} className={cls} />;
          })}
        </div>
        {lastQuestion && (
          <div className="ask">
            <span className="label">여기서 멈췄어요 · AI의 질문</span>
            <p>{lastQuestion}</p>
          </div>
        )}
      </article>

      <span className="grow" />

      <aside className="card dashed" style={{ flexDirection: "row", alignItems: "flex-start", gap: 9, background: "var(--paper)" }}>
        <Icon name="info" size={18} />
        <p style={{ fontSize: 13, fontWeight: 700, lineHeight: 1.55 }}>
          이 토론을 버리고 새로 시작하면 <strong>오늘은 더 못 해요.</strong> 하루 한 번이고, 오늘 몫은 여기에 썼거든요.
        </p>
      </aside>

      <button type="button" className="btn primary" onClick={onContinue} style={{ minHeight: 58, fontSize: 17 }}>
        <span>이어서 하기</span>
        <Icon name="arrow" size={20} stroke="currentColor" />
      </button>
      <button type="button" className="btn" onClick={onLeave} style={{ minHeight: 50, background: "transparent" }}>
        그만두고 다른 사람들 결과 보기
      </button>
    </main>
  );
}
